<template>
  <div class="tw-bg-white dark:tw-bg-dm tw-rounded-2xl tw-border tw-border-gray dark:tw-border-dm-gray tw-flex">
    <div
      v-if="actionDate.action_date"
      class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-border-r tw-border-gray dark:tw-border-dm-gray tw-text-center tw-w-32 tw-flex tw-flex-col tw-justify-center tw-text-xl"
    >
      <div
        class="tw-font-bold tw-text-2xl tw-leading-7"
        :class="getTextColor()"
      >
        {{ $dayjs(actionDate.action_date, 'DD.MM.YYYY').format('DD.MM') }}
      </div>
      <div
        v-if="actionDate.action_time"
        class="tw-leading-6"
      >
        {{ $t('common.prepositions.at') }} {{ actionDate.action_time }}
      </div>
    </div>
    <div class="tw-p-6 tw-flex-1">
      <div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
        <strong
          class="tw-text-xl tw-leading-6"
          :class="getTextColor()"
        >
          {{ actionDate.action_date_type_name }}
        </strong>
      </div>
      <div
        v-if="actionDate.assistance_fullname"
        class="tw-flex tw-items-center tw-mb-3"
      >
        <div class="tw-flex tw-items-center tw-mr-4 tw-leading-5">
          <icon-checkbox-sm class="tw-w-4 tw-mr-2 tw-text-gray-dark dark:tw-text-dm-gray-dark" />
          {{ $capitalize($t('common.pronouns.you')) }} {{ $t('common.prepositions.and') }}
          {{ actionDate.assistance_fullname }}
        </div>
      </div>

      <div class="tw-flex tw-items-center">
        <div
          v-if="actionDate.place_full_address"
          class="tw-flex tw-items-center tw-mr-4 tw-leading-5"
        >
          <icon-pin-sm class="tw-w-4 tw-mr-2 tw-leading-5 tw-text-gray-dark dark:tw-text-dm-gray-dark" />
          {{ actionDate.place_full_address }}
        </div>
        <div
          v-if="actionDate.assistance_phone"
          class="tw-flex tw-items-center tw-mr-4 tw-leading-5"
        >
          <icon-phone-sm class="tw-w-4 tw-mr-2 tw-text-gray-dark dark:tw-text-dm-gray-dark" />
          {{ actionDate.assistance_phone }}
        </div>
      </div>
    </div>
    <div class="tw-p-6 tw-flex tw-flex-col tw-gap-2">
      <i-button
        v-if="actionDate.action_date && actionDate.place_maps_url"
        is-icon
        @click="downloadIcs"
      >
        <icon-calendar-sm />
      </i-button>
      <a
        v-if="actionDate.place_maps_url"
        :href="actionDate.place_maps_url"
        target="_blank"
      >
        <i-button
          is-icon
        >
          <icon-pin-sm />
        </i-button>
      </a>
    </div>
  </div>
</template>

<script>
import { downloadFileByUrlV2 } from '@/helpers';

export default {
  props: {
    actionDate: {
      type: Object,
      required: true,
    },
    permit: {
      type: Object,
      required: true,
    },
    statusId: {
      type: Number,
      required: true,
    },
    isClosest: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    statusDateModifier() {
      const today = this.$dayjs();
      const actionDateTime = this.$dayjs(`${this.actionDate.action_date} ${this.actionDate.action_time}`, 'DD.MM.YYYY HH:mm');
      const diff = actionDateTime.diff(today, 'minutes');
      const diffNormalized = Math.abs(diff);
      if (diffNormalized >= 0) {
        return 'future';
      }
      return 'past';
    },
  },

  methods: {
    downloadIcs() {
      downloadFileByUrlV2(`api_foreigner/permit/${this.permit.id}/status/${this.statusId}/${this.actionDate.id}/ics/`, '', this.$axios);
    },
    getTextColor() {
      if (this.isClosest) return 'tw-text-primary';
      return this.statusDateModifier === 'future' ? 'tw-text-gray-dark' : 'tw-text-dark';
    },
  },
};
</script>
